import SubGoalRow from './SubGoalRow.jsx'
import AddSubgoalButton from './AddSubgoalButton.jsx'
import { SUBGOAL_GRID } from './subgoalGrid.js'

/**
 * SubGoalTable — renders the sub-goal rows inside a goal card's children
 * slot. Used whenever a goal has `subgoals`, regardless of which pillar
 * the goal is in.
 *
 * Props:
 *   pillarName    — passed to SubGoalRow + AddSubgoalButton for mutation routing
 *   goalIndex     — which goal in the pillar we're under
 *   goal          — the parent goal (for defaultOwner / DRI)
 *   subgoals      — the array to render
 */
export default function SubGoalTable({ pillarName, goalIndex, goal, subgoals }) {
  return (
    <div
      style={{
        background: '#fafafa',
        border: '1px solid var(--border)',
        borderRadius: 8,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: SUBGOAL_GRID,
          gap: 10,
          alignItems: 'center',
          padding: '10px 12px',
          background: '#fff',
          borderBottom: '1px solid var(--border)',
          fontSize: 10,
          fontWeight: 700,
          color: 'var(--muted)',
          textTransform: 'uppercase',
          letterSpacing: 0.06,
        }}
      >
        <span>Sub-Goal</span>
        {/* Owner pill has 8px padding + 1px border → shift header to match */}
        <span style={{ paddingLeft: 9 }}>Owner</span>
        <span>Current</span>
        <span>Target</span>
        <span>Progress</span>
        {/* % column is right-aligned in the data row — match here */}
        <span style={{ textAlign: 'right' }}>%</span>
        {/* Update textarea has 8px padding + 1px border → shift header to match */}
        <span style={{ paddingLeft: 9 }}>Update</span>
        <span></span>
      </div>
      {(subgoals || []).map((sub, i) => (
        <SubGoalRow
          key={i}
          sub={sub}
          pillarName={pillarName}
          goalIndex={goalIndex}
          subgoalIndex={i}
        />
      ))}
      <div style={{ padding: 8, background: '#fafafa' }}>
        <AddSubgoalButton
          pillarName={pillarName}
          goalIndex={goalIndex}
          defaultOwner={goal?.dri || goal?.owner}
        />
      </div>
    </div>
  )
}
